module.exports = __webpack_public_path__ + "img/T5-C-rc_26.40819334.png";